export default __webpack_public_path__ + "static/media/MatesMasterLogo_COL.11cc6812.png";